export const EVENT_BANNER_CHANGE = 'banner.change'
